import React from 'react';
import ReceivingIcon from 'components/Icons/ReceivingIcon';
import SendingIcon from 'components/Icons/SendingIcon';
import { TradeMapModel } from './model';

// The four tiles under the map (addendum 12, round 1 item 3): packages
// received (green, the sidebar's Receiving box), packages sent (violet, the
// Sending glyph), trade partners, countries. Icons sit bare, no chip; the label
// sits under the number. Every number is the aggregate's totals object, so the
// trade partners tile equals the sidebar's Trade Partners by construction.
// Phones: a 2x2 grid, numbers only.

const count = (n: number) => n.toLocaleString('en-US');

const TradeStatsRow: React.FC<{ model: TradeMapModel }> = ({ model }) => {
  const { totals } = model;
  return (
    <div className="ptm-stats" data-testid="ptm-stats">
      <div className="ptm-stat ptm-stat--received" data-testid="ptm-stat-received" data-value={totals.received}>
        <span className="ptm-stat-line">
          <ReceivingIcon className="ptm-stat-icon" size={20} />
          <span className="ptm-stat-number">{count(totals.received)}</span>
        </span>
        <span className="ptm-stat-label">packages received</span>
      </div>
      <div className="ptm-stat ptm-stat--sent" data-testid="ptm-stat-sent" data-value={totals.sent}>
        <span className="ptm-stat-line">
          <SendingIcon className="ptm-stat-icon" size={20} />
          <span className="ptm-stat-number">{count(totals.sent)}</span>
        </span>
        <span className="ptm-stat-label">packages sent</span>
      </div>
      <div className="ptm-stat" data-testid="ptm-stat-partners" data-value={totals.partners}>
        <span className="ptm-stat-line">
          <span className="ptm-stat-number">{count(totals.partners)}</span>
        </span>
        <span className="ptm-stat-label">trade partners</span>
      </div>
      <div className="ptm-stat" data-testid="ptm-stat-countries" data-value={totals.countries}>
        <span className="ptm-stat-line">
          <span className="ptm-stat-number">{count(totals.countries)}</span>
        </span>
        <span className="ptm-stat-label">countries</span>
      </div>
    </div>
  );
};

export default TradeStatsRow;
